import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  overflow: hidden;
  border-radius: 10px;
  display: flex;
  height: 150px;
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(134, 134, 134, 0.16);
  background: ${theme.white};

  .image-promotion {
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }

  .info-block {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 15px;

    .card-title {
      font-size: 16px;
    }

    .detail {
      color: ${theme.mediumGray};
    }
    .date {
      color: ${theme.lightGray};
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    height: 130px;
  }

  @media (max-width: ${breakpoint.md}) {
    height: 120px;

    .info-block {
      padding: 8px 14px;

      .detail {
        line-height: 1.2;
        font-size: 12px;
      }
    }
  }
`
